export default __webpack_public_path__ + "static/media/TotemManual40.d2eb9215.jpg";